import { useEffect, useState } from "react";
import { ChevronRight } from "lucide-react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "../ui/carousel";
import { DoctorCard } from "../doctor-card";
import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";

export default function    OurDoctorsWidget() {
  const [doctors, setDoctors] = useState([]);
  const ids = ["29", "31", "32", "33"]; // keep as strings for safe comparison

  useEffect(() => {
    const url = `/wp-json/wp/v2/doctors?include=${ids.join(",")}&acf_format=standard&_embed&per_page=100&orderby=include`;
    console.log("Fetching doctors from:", url);

    fetch(url)
      .then((res) => {
        if (!res.ok) throw new Error("Network response was not ok: " + res.status);
        return res.json();
      })
      .then((data) => {
        // client-side sort to guarantee order exactly as ids array
        const sorted = ids
          .map((id) => data.find((d) => String(d.id) === String(id)))
          .filter(Boolean); // drops any missing ones
        setDoctors(sorted);
      })
      .catch((err) => {
        console.error("Error fetching doctors:", err);
        setDoctors([]);
      });
  }, []);

  return (
    <section className="py-12 bg-gray-100">
      <div className="container px-4 mx-auto">
        <div className="flex flex-col items-center mb-10 text-center">
          <Badge className="mb-2">Our Doctors</Badge>
          <h2 className="mb-4 text-3xl font-bold md:text-4xl">Meet Our Specialists</h2>
          <p className="max-w-2xl text-muted-foreground">
            Our team of experienced and dedicated doctors are committed to providing you with the best medical care.
          </p>
        </div>

        <Carousel className="w-full max-w-5xl mx-auto">
          <CarouselContent>
            {doctors.length > 0 ? (
              doctors.map((doctor) => {
                if (!doctor) return null;
                // safe extraction with fallbacks
                const name = doctor?.title?.rendered || "No name";
                const specialty = doctor?.acf?.expertised_area || "Specialty not available";
                const experience = doctor?.acf?.latest_achievement || doctor?.excerpt?.rendered || "";
                const hospitalDoctorId = doctor?.acf?.doctor_id || null;
                const image =
                  doctor._embedded?.["wp:featuredmedia"]?.[0]?.source_url ||
                  doctor.featured_media_url ||
                  "/placeholder.svg?height=300&width=300&text=Doctor";

                return (
                  <CarouselItem key={doctor.id} className="md:basis-1/2 lg:basis-1/3">
                    <DoctorCard
                      name={name}
                      specialty={specialty}
                      experience={experience}
                      image={image}
                      href={`/doctors/${doctor.slug}`}
                      hospitalDoctorId={hospitalDoctorId}
                    />
                  </CarouselItem>
                );
              })
            ) : (
              <p className="text-center w-full py-6">Loading doctors...</p>
            )}
          </CarouselContent>

          <div className="flex justify-center mt-8">
            <CarouselPrevious className="relative mr-2 left-0" />
            <CarouselNext className="relative ml-2 right-0" />
          </div>
        </Carousel>

        <div className="flex justify-center mt-8">
          <Button
            variant="outline"
            className="gap-2 border-primary text-primary hover:bg-primary hover:text-white"
            asChild
          >
            <Link to="/doctors">
              View All Doctors
              <ChevronRight className="w-4 h-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
